import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Message } from 'src/app/core/class/message';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { DocumentService } from 'src/app/core/services/document.service';

@Component({
  selector: 'app-document-download-success-dialog',
  templateUrl: './document-download-success-dialog.component.html',
  styleUrls: ['./document-download-success-dialog.component.scss']
})
export class DocumentDownloadSuccessDialogComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    private message: Message,
    private dialog: MatDialog,
    private documentService: DocumentService,
    private documentTypeService: DocumentTypeService,
    public dialogRef: MatDialogRef<DocumentDownloadSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
  }

  close(){
    this.dialog.closeAll()
  }

}
